import { render, staticRenderFns } from "./modalBlocked.vue?vue&type=template&id=2f254c08"
import script from "./modalBlocked.vue?vue&type=script&lang=js"
export * from "./modalBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports